import { AxiosPromise } from 'axios';
import { http } from 'services';

// A notebook has ONE chat, keyed by the notebook id (the old per-document and
// `multi:` keys are gone). Encode it so it stays a single path segment.
export const GetChatHistory = (notebookId: string): AxiosPromise =>
  http.request.get(`/api/chat/history/${encodeURIComponent(notebookId)}`);

export const DeleteChatHistory = (notebookId: string): AxiosPromise =>
  http.request.delete(`/api/chat/history/${encodeURIComponent(notebookId)}`);
